import * as actionTypes from "./types";
import * as authService from "./../../auth";
export const guestToken = ({loginData}) => async (dispatch) => {
  dispatch({
    type: actionTypes.AUTH_LOADING_REQUEST,
    payload: { loading: true },
  });

  try{
    const data = await authService.fetchGuestToken({loginData});

    if (data.success === true) {
      data.result.JwtToken
        ? localStorage.setItem("guest-token", data.result.JwtToken)
        : "";
      data.result.JwtToken
        ? localStorage.setItem(
            "CompanyName",
            data.result?.TokenMetadata?.CompanyName
          )
        : "";
      dispatch({
        type: actionTypes.AUTH_LOGIN_SUCCESS,
        payload: data.JwtToken,
      });
      return Promise.resolve(data);

    } else {
      dispatch({
        type: actionTypes.AUTH_FAILED_REQUEST,
        payload: data,
      });
      return Promise.reject(data); // Reject with the error data
    }
  } catch(e) {
    return Promise.reject(e); // Reject with the caught error
  }
};

export const login = ({ loginData }) => async (dispatch) => {
  dispatch({
    type: actionTypes.AUTH_LOADING_REQUEST,
    payload: { loading: true },
  });

  try {
    const data = await authService.login({ loginData });
    if (data?.success === true) {
      dispatch({
        type: actionTypes.AUTH_LOGIN_SUCCESS,
        payload: data.result.JwtToken,
      });
      localStorage.setItem("token", data.result.JwtToken);
      return Promise.resolve(data.result.JwtToken); // Resolve with the JWT token
    } else {
      dispatch({
        type: actionTypes.AUTH_FAILED_REQUEST,
        payload: data,
      });
      return Promise.reject(data); // Reject with the error data
    }
  } catch (error) {
    dispatch({
      type: actionTypes.AUTH_FAILED_REQUEST,
      payload: error,
    });
    return Promise.reject(error); // Reject with the caught error
  }
};
export const logout = () => async (dispatch) => {
  authService.logout();
  dispatch({
    type: actionTypes.AUTH_LOGOUT_SUCCESS,
  });
};
